export class ISetHubSizes{
    message: string;
    constructor ( message: string){
        this.message = message;
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.ts
 **/